import React, { useState } from 'react'

import EditIcon from '../../../assets/images/edit.png'
import ConfirmIcon from '../../../assets/images/ico_confirmar.png'

const InlineInput = ({ item, field, currentItem, setEditingItem, onSubmit, parseFunction = (val) => val }) => {
  const [value, setValue] = useState(parseFunction(item[field]))

  return (
    <div className="inline-input">
      <input
        type="number"
        value={value}
        disabled={currentItem.id !== item.id}
        onChange={({ target }) => setValue(target.value)}
      />
      {currentItem.id !== item.id ? (
        <img src={EditIcon} alt="edit" onClick={() => setEditingItem(item)} />
      ) : (
        <img
          src={ConfirmIcon}
          alt="edit"
          onClick={() => {
            if (isNaN(parseFloat(`${value}`))) return
            onSubmit(field, item.id, value)
            setEditingItem({})
          }}
        />
      )}
    </div>
  )
}

export default InlineInput
